import { CustomAutocomplete, LoaderComponent, ModalAnalisisProductosAComprar, ModalConfirm, ModalProgress, SingleButton } from "@/shared/components/ui";
import { Alert, Grid, Paper, TextField, Typography } from "@mui/material";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useNavigate, useParams } from "react-router-dom";
import { gridSizeMdLg12, gridSizeMdLg4, gridSizeMdLg8, ModulosEnumChoice, ROUTER_PATHS } from "@/shared";
import { useCreateSolicitudesIngresos, useFetchMotivosRechazo, useGetSolicitudPedido, useUpdateSolicitudesEgresos } from "@/shared/actions/erp";
import { useEffect, useMemo, useRef, useState } from "react";
import { EstadosSolicitudPeodidoEnum, MaterialTransferido } from "@/shared/interfaces";
import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store";
import useTableRevisionSolicitudPedido from "../../shared/hook/useTablerRevisionSolicitudPedido";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useUiStore } from "@/store/ui";
import SmartTextArea from "@/shared/components/ui/SmartTextArea";
import dayjs from "dayjs";
import SampleTablePedidoPagination from '@/shared/components/ui/SampleTablePedidoPagination';
import { queryClient } from "@/shared/query-client/query-client";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
const RevisionSolicitudPedido = () => {
  const { id } = useParams()
  ///console.log('id', id)
  ///hook
  const navigate = useNavigate()
  //store
  const handleCopiarLista = useCargarSeriesProductos(s => s.handleCopiarLista)
  const paginatedData = useCargarSeriesProductos(s => s.paginatedData)
  const pagination = useCargarSeriesProductos(s => s.pagination)
  const setPagination = useCargarSeriesProductos(s => s.setPagination)
  const productos = useCargarSeriesProductos(s => s.productos)
  const clearSelectedItems = useCargarSeriesProductos(s => s.clearSelectedItems)
  //onsole.log('productos', productos)
  const setConfirmDialogIsOpen = useUiStore((s) => s.setConfirmDialogIsOpen);
  //const setConfirmDialogIsOpen2 = useUiStore((s) => s.setConfirmDialogIsOpen);
  const setConfirmDialog = useUiStore((s) => s.setConfirmDialog);

  //state
  const [openPreview, setOpenPreview] = useState(false)
  const [IsOpenModalRechazo, setIsOpenModalRechazo] = useState(false)
  const [activedModalMutation, setActivedModalMutation] = useState(false)
  const [openModalAnalisis, setOpenModalAnalisis] = useState(false)
  const [rowSelection, setRowSelection] = useState<Record<string, boolean>>({})
  console.log('rosSelection', rowSelection)
  //marcar / desmarcar todos
  const marcarTodos = () => {
    const todos: Record<string, boolean> = {};
    productos.forEach(p => { todos[String(p.id)] = true; });
    setRowSelection(todos);
  };

  const desmarcarTodos = () => setRowSelection({});
  //hook
  const { infoProducto, columnsCompra } = useTableRevisionSolicitudPedido()
  //fetch
  const { data: dataSolicitudEgreso, isLoading } = useGetSolicitudPedido(id!)
  //console.log('data', dataSolicitudEgreso)
  const { data: dataMotivoRechazo, isLoading: isLoadingRechazo } = useFetchMotivosRechazo({
    page_size: 600,
    modulo: ModulosEnumChoice.PEDIDOS
  })
  //mutate
  const updateSolicitudesPedidos = useUpdateSolicitudesEgresos({})
  const createSolicitudIngreso = useCreateSolicitudesIngresos({
    enableSuccessAlert: false,
    enableRedirect: false,
  })

  ///HELPER
  const esProductoEnMetros = (p: any) =>
  p?.producto_data?.usa_metros === true &&
  p?.contiene_serie === true &&
  Number(p?.producto_data?.metros_base) > 0;

  const metrosAUnidades = (p: any, metros: number) => {
    if (!esProductoEnMetros(p)) return Number(metros) || 0;
    const base = Number(p.producto_data.metros_base);
    return Math.ceil((Number(metros) || 0) / base); // techo: 1.25 -> 2
  };


  useEffect(() => {
    if (isLoading) return;
    if (!dataSolicitudEgreso?.data.productos?.length) return;
    const aux = dataSolicitudEgreso.data?.productos?.map((elemento) => ({
      ...elemento,
      codigo: elemento.codigo!,
      cantidad: elemento.cantidad!,
      id: elemento.id!,
      cantidad_aprobada: Number(elemento.cantidad_metros ?? elemento.cantidad)
    })) as any as MaterialTransferido[]
    //console.log('data', aux)
    handleCopiarLista(aux)
  }, [dataSolicitudEgreso])
  //
  type SaveForm = {
    motivo_rechazo: string;
    observaciones?: {
      observacionSolicitudPedido: string;
      observacionRevisionSolicitudPedido: string;
    }
  }
  const form = useForm<SaveForm>()
  const { formState: { errors } } = form
  //
  const selectedProductos = useMemo(
    () => {
      const selectedIds = Object.keys(rowSelection).filter(id => rowSelection[id])
      if (selectedIds.length === 0) return productos
      return productos.filter(p => selectedIds.includes(String(p.id)))
    },
    [productos, rowSelection]
  )

  //
  // const productosAcomprar = useMemo(
  //   () =>
  //     /* productos.filter((p) => { */
  //         selectedProductos.filter((p) => {
  //       const stock = Number(p.producto_data?.stock_actual ?? 0);
  //       const aprobadaUnid = metrosAUnidades(p, Number(p.cantidad_aprobada ?? 0));
  //       return stock < aprobadaUnid;
  //     })
  //     .map((p) => {
  //       const stock = Number(p.producto_data?.stock_actual ?? 0);
  //       const aprobadaUnid = metrosAUnidades(p, Number(p.cantidad_aprobada ?? 0));
  //       return {
  //         ...p,
  //         cantidad_pendiente: aprobadaUnid - stock,   // en UNIDADES
  //         cantidad_aprobada: aprobadaUnid,            // en UNIDADES (este arreglo es solo para la compra)
  //       };
  //     }),
  //   [selectedProductos]
  // )
  const productosAcomprar = useMemo(
    () => 
      selectedProductos.filter((p) =>{
        if ( esProductoEnMetros(p)){
          const metrosDisponibles = Number((p).metros_disponibles ?? 0);
          const metrosSolicitados = Number(p.cantidad_aprobada ?? 0);
          return metrosDisponibles < metrosSolicitados;
        }
        const stock = Number(p.producto_data?.stock_actual ?? 0);
        const aprobada = Number(p.cantidad_aprobada ?? 0);
        return stock < aprobada;
      })
      .map((p) => {
        if(esProductoEnMetros(p)){
          const metrosDisponibles = Number(p.metros_disponibles ?? 0);
          const metrosSolicitados = Number(p.cantidad_aprobada ?? 0);
          const base = Number(p.producto_data?.metros_base ?? 0) || 1;
          const metrosFaltante = Math.max(metrosSolicitados - metrosDisponibles, 0);
          const unidadesComprar = Math.ceil(metrosFaltante / base);
          return { ...p, cantidad_pendiente: unidadesComprar, cantidad_aprobada: unidadesComprar };
        }
        const stock = Number(p.producto_data?.stock_actual ?? 0);
        const aprobada = Number(p.cantidad_aprobada ?? 0);
        return { ...p, cantidad_pendiente: aprobada - stock, cantidad_aprobada: aprobada }
      }),
      [selectedProductos]
  )
  //console.log('productos a comprar', productosAcomprar)
  //update pedido 
  const onSaveUpdate = async (): Promise<boolean> => {
    const campoCantidadAprobadaInvalida = selectedProductos.find(item => item.cantidad_aprobada! <= 0 || isNaN(item.cantidad_aprobada!))
    if (campoCantidadAprobadaInvalida) {
      toast.error(`El producto "${campoCantidadAprobadaInvalida.codigo}" tiene una cantidad aprobada inválida, debe ser mayor a  cero.`)
      return false;
    }
    const observacionActual = dataSolicitudEgreso?.data.observaciones || {}
    const selectedIds = Object.keys(rowSelection).filter(id => rowSelection[id])
    const haySeleccion = selectedIds.length > 0
    let productosEnviar
    if (haySeleccion) {
      productosEnviar = productos.map(p => ({
        ...p,
        estado: selectedIds.includes(String(p.id)) ? 'APROBADO' : 'RECHAZADO'
      }))
    } else {
      productosEnviar = selectedProductos
    }
    productosEnviar = productosEnviar.map(p => {
      const stock = Number(p.producto_data?.stock_actual ?? 0);
      const aprobadaMetros = Number(p.cantidad_aprobada ?? p.cantidad ?? 0); // sigue en metros
      const aprobadaUnid = metrosAUnidades(p, aprobadaMetros);               // solo para operar
      const esAprobado = haySeleccion ? selectedIds.includes(String(p.id)) : true;
      return {
        ...p, // conserva cantidad y cantidad_aprobada en METROS -> el back convierte
        cantidad_a_entregar: esAprobado ? Math.min(stock, aprobadaUnid) : 0, // unidades
        cantidad_pendiente: esAprobado ? aprobadaUnid : 0,
        cantidad_transferido: 0,
      };
    });
    const revisionPedido: any = {
      id: id,
      data: {
        estado_solicitud: EstadosSolicitudPeodidoEnum.APROBADAS,
        productos: productosEnviar,
        observaciones: {
          ...observacionActual,
          observacionRevisionSolicitudPedido: form.getValues('observaciones.observacionRevisionSolicitudPedido')
        }
      }
    }
    console.log('payload aprobacion', revisionPedido)
    console.log('payload JSON: ', JSON.stringify(revisionPedido, null, 2))
    // return true;
    try {
      const result = await updateSolicitudesPedidos.mutateAsync(revisionPedido)
      if (result.code !== 200) return false;
      queryClient.invalidateQueries({ queryKey: ['solicitud-egresos'], refetchType: 'all' })
      return true
    } catch (error) {
      console.log('Al momento de mutar se genero un error.', error)
      return false
    }
  }
  //
  const handleUpdateMotivo = () => {
    if (form.getValues().motivo_rechazo === "")
      return toast.error("Seleccione un motivo, para proceder con la confirmación.")
    const observacionActual = dataSolicitudEgreso?.data.observaciones || {}
    const solicitudPedidoRechazo = {
      id: id!,
      data: {
        estado_solicitud: EstadosSolicitudPeodidoEnum.RECHAZADO,
        motivo_rechazo: form.getValues().motivo_rechazo,
        observaciones: {
          ...observacionActual,
          observacionRevisionSolicitudPedido: form.getValues('observaciones.observacionRevisionSolicitudPedido')
        }
      }
    }
    /* console.log('rechazo', solicitudPedidoRechazo)
    return; */
    setConfirmDialog({
      isOpen: true,
      subtitle: "¿Está seguro que deseas rechazar el pedido seleccionado?",
      title: "Confirmar rechazo",
      onClose() {
        setConfirmDialogIsOpen(false)
      },
      onConfirm: async () => {
        try {
          setIsOpenModalRechazo(false)
          setConfirmDialogIsOpen(false)
          const result = await updateSolicitudesPedidos.mutateAsync(solicitudPedidoRechazo)
          if (result.code !== 200) return;
          navigate(ROUTER_PATHS.inventario.solicitud_pedido_nav)
          clearSelectedItems()

        } catch (error) {
          console.log("Error al mutar", error)
        }

      },
    })
  } 
  ////envio a otra pagina 
  const handleAprobar = () => {
    setConfirmDialog({
      isOpen: true,
      title: "¡Aprobado con éxito",
      subtitle: "La solicitud de pedido se ha aprobado correctamente, deseas realizar la trasferencia. ¿Te gustaría continuar?",
      onClose() {
        setConfirmDialogIsOpen(false)
      },
      onConfirm() {
        setConfirmDialogIsOpen(false)
        // return navigate(`${ROUTER_PATHS.inventario.trasladoInventarioSolicitudEgresoNav.replace(':id_solicitudegreso', String(id))}?soloDisponibles=1`)
        return navigate(`${ROUTER_PATHS.inventario.transferenciaInventarioSolicitudEgresoNav.replace(':id_solicitudegreso', String(id))}`);

        
        // return navigate(`${ROUTER_PATHS.inventario.transferenciaInventarioSolicitudEgresoNav.replace(':id_solicitudegreso', String(idSolicitudEgreso))}`);

      },
    })
  }
  ////// solicitud de compra 
  const fechaActual = new Date()
  const formatDate = dayjs(fechaActual).format('YYYY-MM-DD')
  const bodega = dataSolicitudEgreso?.data?.bodega
  const ubicacion = dataSolicitudEgreso?.data?.ubicacion

  const handleSolicitudCompra = async () => {
    const solicitudIngreso = {
      fecha_creacion: formatDate,
      observaciones: {
        observacionSolicitante: 'Generado apartir de solicitud Pedido stock 0'
      },
      bodega: bodega,
      ubicacion: ubicacion,
      productos: productosAcomprar.map(item => {
        return {
          id: item.id,
          codigo: item.codigo,
          cantidad: String(item.cantidad_pendiente), // pedido solo lo que falta
          contiene_serie: item.contiene_serie,
          producto_data: {
            codigo: item.codigo,
            categoria_producto: item.producto_data?.categoria_producto,
            subcategoria_producto: item.producto_data?.subcategoria_producto,
            descripcion: item.producto_data?.descripcion,
            stock_actual: item.producto_data?.stock_actual,
            modelo_producto: item.producto_data?.modelo_producto,
            marca_producto: item.producto_data?.marca_producto,
            unidad_medida: item.producto_data?.unidad_medida,
            presentacion: item.producto_data?.presentacion,
          },
          series: []

        }
      })
    } as any
    console.log('solictudIngreso', solicitudIngreso)
    await createSolicitudIngreso.mutateAsync(solicitudIngreso)
  }



  if (isLoading) return <LoaderComponent></LoaderComponent>

  return (
    <>
      <Typography variant="h5">{'REVISIÓN DE SOLICITUD DE PEDIDO'}</Typography>
      <Grid container spacing={2}>
        <Grid item container spacing={1} justifyContent={'flex-end'} mt={1}>
          <Grid item>
            <SingleButton
              variant="outlined"
              startIcon={<ArrowBackIosIcon />}
              label="Volver"
              color={'primary'}
              onClick={() => { navigate(`${ROUTER_PATHS.inventario.solicitud_pedido_nav}`) }}
            />
          </Grid>
          <Grid item>
            <SingleButton
              variant="outlined"
              startIcon={<AddIcon />}
              label="Marcar todos"
              color={'primary'}
              onClick={marcarTodos}
            />
          </Grid>
          <Grid item>
            <SingleButton
              variant="outlined"
              startIcon={<RemoveIcon />}
              label="Quitar selección"
              color={'primary'}
              onClick={desmarcarTodos}
            />
          </Grid>
          <Grid item>
            <SingleButton
              variant="outlined"
              startIcon={<CheckCircleOutlineIcon />}
              label="Aprobar"
              color={'success'}
              onClick={() => setOpenPreview(true)}
            //onClick={onSaveUpdate}
            />

          </Grid>

          <Grid item>
            <SingleButton
              variant="outlined"
              startIcon={<HighlightOffIcon />}
              label="Rechazar"
              color={'error'}
              onClick={() => { setIsOpenModalRechazo(true) }}
            />

          </Grid>
        </Grid>
        <SmartTextArea
          label="Observación Solicitante"
          name="observacion"
          control={form.control}
          texto={dataSolicitudEgreso?.data.observaciones?.observacionSolicitudPedido || 'N/A'}
          title="Observación"
          size={gridSizeMdLg4}
          rows={1}
          maxPreviewWords={20}
        />
        <Grid item {...gridSizeMdLg8}>
          <Controller
            name="observaciones.observacionRevisionSolicitudPedido"
            control={form.control}
            rules={{ required: "Campo requerido" }}
            render={({ field }) => {
              const inputRef = useRef<HTMLInputElement | null>(null)
              return (
                <TextField
                  {...field}
                  variant="outlined"
                  label="Observación"
                  multiline
                  rows={1}
                  fullWidth
                  required={false}
                  error={!!errors.observaciones?.observacionRevisionSolicitudPedido}
                  helperText={errors.observaciones?.observacionRevisionSolicitudPedido?.message}
                  inputProps={{ style: { textTransform: 'uppercase' } }}
                  inputRef={inputRef}
                  onChange={(e) => {
                    const start = e.target.selectionStart;
                    const end = e.target.selectionEnd;
                    const upper = e.target.value.toUpperCase();
                    field.onChange(upper)
                    requestAnimationFrame(() => {
                      if (inputRef.current) {
                        inputRef.current.setSelectionRange(start, end)
                      }
                    })
                  }}
                />
              )
            }}
          />
        </Grid>
        <Grid item {...gridSizeMdLg12}>
          <Paper className="productos">
            <SampleTablePedidoPagination
              columns={infoProducto}
              data={paginatedData}
              pagination={pagination}
              setPagination={setPagination}
              rowCount={productos.length}
              enableRowSelection
              rowSelection={rowSelection}
              onRowSelectionChange={setRowSelection}
              getRowId={(row) => String(row.id)}
              enableSelectAll={false}
            />
          </Paper>
        </Grid>
      </Grid>
      {
        IsOpenModalRechazo && (
          <ScrollableDialogProps
            open={IsOpenModalRechazo}
            title="Rechazar Pedido"
            onCloseIcon={() => { setIsOpenModalRechazo(false), form.setValue('motivo_rechazo', '') }}
            onClose={() => setIsOpenModalRechazo(false)}
            showRejectBtn={true}
            rejectVariantBtn={'outlined'}
            rejectBtnColor="error"
            onReject={handleUpdateMotivo}
            contentNode={
              <CustomAutocomplete
                label="Motivo Rechazo"
                name="motivo_rechazo"
                options={dataMotivoRechazo?.data.data || []}
                isLoadingData={isLoadingRechazo}
                valueKey={'nombre'}
                actualValueKey={'codigo'}
                defaultValue={form.getValues().motivo_rechazo || ''}
                control={form.control}
                error={errors.motivo_rechazo}
                helperText={errors.motivo_rechazo?.message}
              />

            }
          />
        )
      }
      <ModalProgress
        open={activedModalMutation}
        message="Generando una solicitud de compra..."
      />

      <ModalConfirm
        open={openPreview}
        //title="Productos A Comprar"
        title={productosAcomprar.length>0
          ? "Productos a Comprar"
          :"Revisión Completada"
        }
        subtitle={productosAcomprar.length > 0 
          ? "¡Atención! Estos productos generarán una solicitud de compra al confirmar. Si no lo desea, presione en cancelar."
          : ""
        }
        contentNode={
          <>
             {!productosAcomprar.length && (
              <Alert severity="success">
              Todos los productos cuentan con stock suficiente. No es necesario generar solictud de  compra.
              </Alert>
            )} 
            {productosAcomprar.length > 0 && (
              <SampleTablePedidoPagination
                columns={columnsCompra}
                data={productosAcomprar}
                pagination={pagination}
                setPagination={setPagination}
                rowCount={productosAcomprar.length}
              />
            )}

          </>

        }
        footerText={productosAcomprar.length>0
          ? "Confirmo la solicitud de compra"
          :""
        }
        onClose={async () => {
          setOpenPreview(false)
          //toast.success("Gracias por su confirmación. No se creo ningun solictud de compra.")

          //await queryClient.invalidateQueries({ queryKey: ['solicitud-egresos'], refetchType: 'all' })
          //clearSelectedItems();
          //return navigate(ROUTER_PATHS.inventario.solicitud_pedido_nav)

        }}
        confirmText={productosAcomprar.length>0
          ?"Confirmar"
          :"Entendido"
        }
        onConfirm={async () => {
          setOpenPreview(false)
          const success = await onSaveUpdate()
          /* if (success) {
            setOpenModalAnalisis(true)
          } */
         if (!success) return;
         if(productosAcomprar.length > 0){
          setOpenModalAnalisis(true)
         }else{
          clearSelectedItems();
          navigate(ROUTER_PATHS.inventario.solicitud_pedido_nav)
         }
        }}
      />
      {openModalAnalisis && (
        <ModalAnalisisProductosAComprar
          open={openModalAnalisis}
          productos={productosAcomprar}
          onClose={() => setOpenModalAnalisis(false)}
          onConfirm={async () => {
            setOpenModalAnalisis(false)
            setActivedModalMutation(true)
            await handleSolicitudCompra();
            setActivedModalMutation(false)
            toast.success("Solicitud de compra generada correctamente", {
              autoClose: 2000,
              onClose: () => handleAprobar()
            })
            clearSelectedItems();
            // navigate(ROUTER_PATHS.inventario.solicitud_pedido_nav)
          }}
        />
      )}


    </>
  )
}
export default RevisionSolicitudPedido;